import React from 'react';
import { Route } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userContextActions } from '../store/userContextStore'

import PublicLayout from './template/publicLayout'

const PublicRoute = ({ component: Component, user, layout, ...rest }) => (
    <Route path={rest.path} render={() => {
        const L = layout || PublicLayout;
        return <L component={Component} user={user}/>
    }}/>
)

export default connect(
    state => ({ user: state.userContext }),
    dispatch => bindActionCreators(userContextActions, dispatch)
)(PublicRoute)